import { useCallback, useMemo } from 'react';

const useFullyVaccinated = ({ dispatch, value, initValue }) => {
  const onChange = useCallback(
    (selectedType) => {
      dispatch({ type: 'FULLY_VACCINATED_CHANGE', payload: selectedType.value });
    },
    [dispatch]
  );

  return useMemo(() => ({ value, defaultValue: value, onChange, isChanged: initValue !== value }), [
    value,
    onChange,
    initValue
  ]);
};

export default useFullyVaccinated;
